import { connect } from 'react-redux';
import { config } from '../../config';
import App from './App';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from './appSlice';
import { type DisplayMessages, getDisplayMessages, getLocale } from '../../configuration/lang/langSlice';
import { getUserProfile, isUserSessionExpired, type RioUserProfile } from '../../configuration/login/loginSlice';
import messagesEN from '../translations/en-GB.json';
import { getIdToken } from '../../configuration/tokenHandling/tokenSlice';
import type { RootState } from '../../configuration/setup/store';
import type { Dispatch } from '@reduxjs/toolkit';

export interface AppPropertiesFromDispatch {
    hideSessionDialog: () => void;
}

export interface AppPropertiesFromState {
    homeRoute: string;
    displayMessages: DisplayMessages;
    showSessionExpired: boolean | undefined;
    userLocale: string;
    idToken: string | undefined;
    profile: RioUserProfile | null;
}

const mapDispatchToProps = (dispatch: Dispatch): AppPropertiesFromDispatch => ({
    hideSessionDialog: () => dispatch(hideSessionExpiredDialog()),
});

const mapStateToProps = (state: RootState): AppPropertiesFromState => ({
    homeRoute: config.homeRoute as string,
    displayMessages: getDisplayMessages(state) ? (getDisplayMessages(state) as DisplayMessages) : messagesEN,
    showSessionExpired: isUserSessionExpired(state) && !getSessionExpiredAcknowledged(state),
    userLocale: getLocale(state) ? (getLocale(state) as string) : 'en-GB',
    idToken: getIdToken(state)?.rawValue as string,
    profile: getUserProfile(state),
});

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;
